module.exports = __webpack_public_path__ + "media/images/pc/stores/common/visit_reservations_enpou_button-4a5c8e4db406d0df4b28a114627ebea6.png";